import React from "react";
import axios from "axios";
import moment from "jalali-moment";
import {Groups} from "../constants";
import {Row, Image} from "react-bootstrap";
import { withRouter } from "react-router-dom";
import {Loading} from "./partials/Global/Loading";
import {CopyRight} from "./partials/Global/CopyRight";
import {FooterBody} from "./partials/Global/FooterBody";
import {Navigation} from "./partials/Global/Navigation";
import {DottedLoading} from "./partials/Global/DottedLoading";
import {ProgressScrollButton} from "./partials/Global/ProgressScrollButton";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

class RenovationDetail extends React.Component {
    constructor(props) {
        super(props);
        const query = new URLSearchParams(this.props.location.search);
        const renovation = Object.fromEntries([...query]);

        this.state = {
            renovation,
            isLoading: true,
            images: []
        };
    }

    componentDidMount() {
        axios
            .post(
                process.env.REACT_APP_API_URL +
                process.env.REACT_APP_GET_RENOVATION_IMAGES_PATH,
                {
                    apiKey: process.env.REACT_APP_API_PUBLIC_TOKEN,
                    id: this.props.match.params.id
                }
            )
            .then(response => {
                if (
                    response.data.result &&
                    response.data.result.status === true
                ) {
                    const images = response.data.result.data.images;
                    this.setState({ images, isLoading: false });
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    renderRenovationInfo = () => {
        let group = Groups.find(item => item.id == this.state.renovation.group_id);
        const activity_end_date = moment(this.state.renovation.activity_end_date, 'YYYY/MM/DD')
            .locale('fa')
            .format('YYYY/MM/DD');
        return (
            <Row className="pb-30">
                <div className="col-lg-5">
                    <div className="caption md-mb50">
                        <h1 className='fz-40' style={{lineHeight: '1.5'}}>{this.state.renovation.name}</h1>
                    </div>
                </div>
                <div className="col-lg-7 d-flex justify-content-start align-items-end">
                    <div className="row fz-16">
                        <div className="col-md-12">
                            <ul className="rest dot-list">
                                <li className="mb-15"><b>وضعیت پروژه : </b>{group.name}</li>
                                <li className="mb-15"><b>مساحت پروژه : </b>{this.state.renovation.area}</li>
                                <li className="mb-15"><b>{this.state.renovation.group_id == 2 ? 'پیش‌بینی اتمام: ' : 'تاریخ اتمام فعالیت : '}</b>{activity_end_date}</li>
                                <li className="mb-15"><b>آدرس پروژه : </b>{this.state.renovation.address}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </Row>
        )
    };

    renderRenovationGallery = () => {
        if (this.state.images.length === 0) {
            return null;
        }

        const settings = {
            lazyLoad: 'ondemand',
            slidesToShow: (this.state.images.length >= 3) ? 3 : this.state.images.length,
            slidesToScroll: 1,
            infinite: false,
            autoplay: false,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: false,
                        centerMode: false,
                        centerPadding: '40px',
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        arrows: false,
                        centerMode: false,
                        centerPadding: '40px',
                        slidesToShow: 1
                    }
                }
            ]
        };

        return (
            <section className="work-carsouel full-height valign section-padding pt-0">
                <div className="container-fluid rest">
                    <div className="row">
                        <div className="col-12">
                            <div className="slider-carousel">
                                <Slider {...settings}>
                                    {this.state.images.map((image, key) => {
                                        const image_src = image ?? process.env.REACT_APP_BASE_URL + "/images/default/renovation.jpg";
                                        return (
                                            <article key={key} className="carousel-direction">
                                                <div className="property_item heading_space">
                                                    <div className="image">
                                                        <Image
                                                            src={image_src}
                                                            alt="latest property"
                                                            className="img-responsive"
                                                            style={{height: 400}}
                                                        />
                                                    </div>
                                                </div>
                                            </article>
                                        );
                                    })}
                                </Slider>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    };

    render() {
        return (
            <>
                <Loading/>
                <ProgressScrollButton/>
                <Navigation/>
                <main className="main-bg">
                    <header className="proj-header1">
                        <div className="container">
                            {this.renderRenovationInfo()}
                        </div>
                    </header>
                    {!this.state.isLoading
                        ? this.renderRenovationGallery()
                        : <div className='mt-30 mb-80 text-center' style={{marginRight: '49%'}}><DottedLoading/></div>}
                </main>
                <footer className="pt-80 sub-bg">
                    <FooterBody/>
                    <CopyRight/>
                </footer>
            </>
        );
    }
}

export default withRouter(RenovationDetail);
